<template>
  <v-container fluid class="qmkey-vocabulary-view">
    <v-row dense class="d-flex mb-0 pb-0" style="height: 50px">
      <!-- View Title -->
      <v-col class="d-flex mt-1 mb-0 pb-0 ml-2" md="auto">
        <ViewTitle title="Vocabulary" />
      </v-col>
      <v-col class="d-flex mb-0 pb-0" >
        <v-btn
          rounded
          class="add-button"
          @click.stop="addVocabularyForm()"
          >
            Add Vocabulary
        </v-btn>
      </v-col>
    </v-row>
    <v-treeview
      :items="items"
      item-key="id"
      :open="expanded"
      dense
      class="qmkey-vocabulary-datatable"
    >
      <template v-slot:append="{ item }">
        <v-icon
          v-if="item.children"
          small
          @click.stop="addVocabularyKey(item.name)"
          class="qmkey-add-button-vocabulary"
        >
          mdi-plus
        </v-icon>        
        <v-icon
          v-else
          small
          icon
          @click.stop="editVocabularyForm(item.id)"          
          class="qmkey-add-button-vocabulary"
        >
          mdi-pencil
        </v-icon>        
        <v-icon
          small
          icon
          class="mr-2"
          color="error"
          @click.stop="deleteVocabularyForm(item.id)"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>

    </v-treeview>

    <!-- Add /edit dialog -->
    <v-dialog max-width="600px" v-model="showEdit" persistent>
      <v-card
        class="mx-auto"
        :loading="loading">
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn
            text @click="close"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle 
          class="pb-0"
          v-if="modalSubTitle"
        >
          {{ modalSubTitle }}
        </v-card-subtitle>
        <v-card-text>
          <v-form ref="editVocabulary" v-model="valid">
            <v-alert
              :value="alert"
              color="error"
              dark
              icon="mdi-alert"
              transition="scale-transition"
              outlined
              dismissible
              @input="alert=false"
            >
              {{ message }}
            </v-alert>
            <v-text-field
              id="sitename"
              v-model="currentVocabulary.vocabulary"
              type="text"
              required
              placeholder="Enter Vocabulary Name"
              label="Vocabulary name"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              id="vocabularykey"
              v-model="currentVocabulary.key"
              type="text"
              required
              placeholder="Enter Vocabulary Key"
              label="Vocabulary Key"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              id="vocabularyvalue"
              v-model="currentVocabulary.value"
              type="text"
              required
              placeholder="Enter Vocabulary value"
              label="Vocabulary value"
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              id="vocabularypath"
              v-model="currentVocabulary.path"
              type="text"
              required
              placeholder="Enter Vocabulary path"
              label="Vocabulary path"
              :rules="[rules.required]"
            ></v-text-field>                
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>          
          <v-btn class="mr-4" @click="processForm">Ok</v-btn>
          <v-btn @click="clear">Clear</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Delete vocabulary modal -->
    <v-dialog max-width="500px" v-model="showDelete">
      <v-card
        class="mx-auto"
        :loading="loading"
        >
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
        </v-card-title>
        <v-card-text>
          Do you want to delete vocabulary:
          <strong>{{currentVocabulary.key}}</strong>?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-4" @click="processDelete">Ok</v-btn>
          <v-btn @click="showDelete=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>    
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import ViewTitle from '@/components/ViewTitle'
import QVocabulary from '@/api/QVocabularyItem'

export default {
  name: 'VocabularyView',
  components: {
    ViewTitle,
  },

  data() {
    return {
      fields: [
        { value: 'id', text: ''},
        { value: 'vocabulary', text: 'Vocabulary' },
        { value: 'site', text: 'Site' },
        { value: 'key', text: 'Key' },
        { value: 'value', text: 'Value' },
        { value: 'path', text: 'Path' },
        { value: 'actions', text: '', sortable:false },
      ],
      message: null,
      modalTitle: null,
      modalSubTitle: null,
      alert: false,
      showEdit: false,
      loading: false,
      showDelete: false,
      rules: {
        required: value => !!value || "Required.",
      },
      valid: false,
      expanded: [],
      togglers: {},
    }
  },

  computed: {
    ...mapState(['isLoading', 'sitePath']),
    ...mapState('QVocabulary', ['currentVocabulary', 'error', 'vocabularies']),
    items: function(){
      return this.fetchItems()
      // return this.itemsing

    }
  },

  mounted: function() {
    this.SET_CURRENT_SITE(this.$session.get('site'))
    this.GET_VOCABULARIES()
  },

  methods: {
    ...mapActions('QVocabulary', [
      'ADD_VOCABULARY',
      'DELETE_VOCABULARY',
      'GET_VOCABULARY',
      'GET_VOCABULARIES',
      'UPDATE_VOCABULARY',
      'COPY_FROM_PARENT',
    ]),
    ...mapMutations('QVocabulary', ['SET_CURRENT_VOCABULARY']),
    ...mapMutations(['SET_CURRENT_SITE', 'SHOW_ALERT']),

    // Helper to display Vocabulary name
    vocabularyTitle(data) {
      return '- - '.repeat(data.indent) + data.vocabulary
    },

    // Forms
    addVocabularyForm(parent) {
      let currentVocabulary = {}
      this.modalTitle = 'Add new vocabulary'
      if (parent !== undefined) {
        currentVocabulary.vocabulary = parent
        this.modalTitle = 'Add new vocabulary key'
      }
      currentVocabulary.path = this.sitePath
      this.SET_CURRENT_VOCABULARY(currentVocabulary)
      this.showEdit = true
      this.alert = false
    },

    async editVocabularyForm(id) {
      this.message = null
      this.SET_CURRENT_VOCABULARY({})
      try {
        await this.GET_VOCABULARY(id)
        this.modalTitle = `Edit vocabulary #${id}`
        this.showEdit = true
      } catch (err) {
        // this.SHOW_ALERT(`Error ${err.response.status} getting vocabulary ${id}`)
        this.render_form_errors(err)
        this.alert = true
      }
    },

    async deleteVocabularyForm(id) {
      this.message = null
      try {
        await this.GET_VOCABULARY(id)
        this.modalTitle = `Delete Vocabulary #${id}`
        this.showDelete = true
      } catch (error) {
        this.SHOW_ALERT(`Error ${error.response.status} getting vocabulary ${id}`)
      }
    },

    async processForm(evt) {
      if (evt) evt.preventDefault()
      this.message = null
      try {
        if (this.currentVocabulary.id !== undefined) {
          await this.UPDATE_VOCABULARY(this.currentVocabulary)
        } else {
          await this.ADD_VOCABULARY(this.currentVocabulary)
        }
        this.showEdit = false
      } catch (error) {
        this.render_form_errors(error)
        this.alert = true
      }
    },

    async processDelete(evt) {
      if (evt) evt.preventDefault()
      try {
        await this.DELETE_VOCABULARY(this.currentVocabulary)
        this.showDelete = false
      } catch (error) {
        this.render_form_errors(error)
      }
    },

    async copyParentVocabulary() {
      try {
        await this.COPY_FROM_PARENT()
      } catch (error) {
        this.render_form_errors(error)
      }
    },
    clear: function() {
      this.message = '';
      this.alert = false;
      this.$refs.editVocabulary.resetValidation()
      this.currentSite = {}
    },
    close: function() {
      this.$refs.editVocabulary.reset()
      this.message = '';
      this.alert = false;
      this.showEdit = false
    },
    toggleAll () {
      Object.keys(this.$refs).forEach(k => {
        //console.log(this.$refs[k])
        this.$refs[k].$el.click()
      })
    },
    closeAll () {
      Object.keys(this.$refs).forEach(k => {
          console.log(this.$refs[k])
          if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
              this.$refs[k].$el.click()
          }
      })
    },
    openAll () {
      Object.keys(this.$refs).forEach(k => {
          if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
              this.$refs[k].$el.click()
          }
      })
    },
    addVocabularyKey(group){
      this.addVocabularyForm(group)
    },

    fetchItems(){
      console.log('this.vocabularies', this.vocabularies)
      var grouped = _.groupBy(this.vocabularies, 'vocabulary')
      console.log(grouped)
      var new_list = []
      
      for (var k in grouped) {
        console.log(k)
        var item = {}
        item.id = k
        item.name = k
        item.children = []
        for (var i in grouped[k]){
          let child = grouped[k][i]
          console.log(child)
          var new_child = {}
          new_child.name = child.value
          new_child.id = child.id
          new_child.obj = child
          item.children.push(new_child)
        }
        new_list.push(item)
      }
      console.log(new_list)
      return new_list
    },
    testClick(item){
      console.log(item)
    }
  },
}
</script>
<style>
  .qmkey-vocabulary-datatable {
    font-family: 'Trebuchet MS', sans-serif !important;
    font-size: 10px !important;
  }
  .qmkey-add-button-vocabulary{
    color: #85a43c !important;
  }
  .qmkey-add-button-vocabulary > .v-btn__content{
    font-family: 'Trebuchet MS', sans-serif !important;
    font-size: 10px !important;
    text-transform: none;
  }
  .add-button {
    border-color: #85a43c !important;
    background-color: #85a43c !important;
    border-radius: 28px!important;
    color: white !important;
    font-family: 'Trebuchet MS', sans-serif !important;
    font-size: 10px !important;
  }
  .selected-row {
    background-color: #ebebeb;
  }
  .qmkey-item-row{
    font-size: 10px !important;
  }
  .qmkey-vocabulary-view .v-data-table th {
    font-weight: bold !important;
    font-size: 1em !important;
  }
  .qmkey-vocabulary-view .v-data-table .v-data-table__wrapper{
    margin-top: 0px!important;
  }
  .qmkey-vocabulary-view .v-data-table .v-data-table__wrapper td.text-start{
    font-size: 10px !important;
    white-space: nowrap;
    text-overflow:ellipsis;
    overflow: hidden;
    max-width: 300px !important;
  }
  .qmkey-vocabulary-view .v-data-table .v-data-table__wrapper th.text-start{
    font-size: 12px !important;
    white-space: nowrap; 
    text-overflow:ellipsis; 
    overflow: hidden;
    max-width: 300px !important;
  }
  .qmkey-vocabulary-view .theme--light.v-data-table .v-data-table-header th.sortable.active, 
  .qmkey-vocabulary-view .theme--light.v-data-table .v-data-table-header th.sortable.active .v-data-table-header__icon, 
  .theme--light.v-data-table .v-data-table-header th.sortable:hover {
  color:#85a43c!important;
  }
  .qmkey-vocabulary-view tr.v-data-table__selected {
    background-color: #DDDDDD !important;
    font-weight: bold !important;
  }
  .qmkey-vocabulary-view .v-data-table__selected .v-data-table__checkbox .v-icon{
    color:#85a43c!important;
  }
  .qmkey-vocabulary-view .v-data-table-header .v-data-table__checkbox .v-icon {
    color:#85a43c!important;
  }
  .qmkey-vocabulary-view{
    padding: 1px !important;
    font-family: 'Trebuchet MS', sans-serif !important;
  }
  .qmkey-vocabulary-view .v-data-footer{
    font-size: 10px !important;
  }
</style>
